module.exports = __webpack_public_path__ + "static/media/400058_01.c8641f8b.png";